'use client';

import { useEffect, useRef } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { getStorageUrl } from '@/config/instructorImages';
import styles from './Hero.module.css';
import { trackEvent } from '@/lib/analytics/firebaseAnalytics';
import { AnalyticsEvents } from '@/lib/analytics/events';
import { scrollToLandingSection } from '@/utils/scrollToLandingSection';

// Hero images - direct Firebase Storage URLs, no Firestore lookup needed
// These match the configured images in CRM settings/images
// To change: update these filenames to match what's in Firebase Storage landing/pose/
const HERO_CARD_IMG = getStorageUrl('IMG_1459_Original2.jpg');
const HERO_BG_IMG = getStorageUrl('IMG_3563 2.jpg');

const Hero = () => {
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    // Track hero section view (only once)
    if (hasTrackedRef.current) return;
    hasTrackedRef.current = true;
    trackEvent(AnalyticsEvents.VIEW_HERO_SECTION);
  }, []);

  const handleCTAClick = (ctaType: string) => {
    trackEvent(AnalyticsEvents.CLICK_JOIN_BUTTON, {
      source: 'hero',
      cta_type: ctaType,
    });
  };

  const handleBeginJourneyClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    handleCTAClick('begin_journey');
    scrollToLandingSection('pricing');
  };

  return (
    <section className={styles.hero} id="home">
      <div className={styles.heroBackground}>
        <Image
          src={HERO_BG_IMG}
          alt="Gym Training Background"
          fill
          priority
          quality={90}
          className={styles.heroBackgroundImage}
        />
        <div className={styles.overlay}></div>
      </div>

      <div className={styles.container}>
        <div className={styles.heroContent}>
          <div className={styles.heroLeft}>
            <div className={styles.floatingPhotoFrame}>
              <Image
                src={HERO_CARD_IMG}
                alt="Training Pose"
                width={250}
                height={350}
                priority
                quality={90}
                className={styles.floatingPhoto}
              />
            </div>
          </div>

          <div className={styles.heroRight}>
            <div className={styles.heroText}>
              <h1 className={styles.heroTitle}>
                <Image
                  src="/FULL_W_2048.png"
                  alt="Lior Murphy - Backbends and Splits"
                  width={600}
                  height={200}
                  priority
                  style={{ width: '100%', height: 'auto', maxWidth: '600px' }}
                />
              </h1>
            </div>
            <div className={styles.buttonGroup}>
              <Link
                href="#pricing"
                className={styles.btnSecondary}
                onClick={handleBeginJourneyClick}
              >
                Begin Your Journey
              </Link>
              <Link
                href="/classes"
                className={styles.btn}
                onClick={() => handleCTAClick('class_details')}
              >
                Class Details
              </Link>
              <Link
                href="/about"
                className={styles.btn}
                onClick={() => handleCTAClick('about_me')}
              >
                About Me
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
